var _ = require('lodash')

window._ = _